import { Flex, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StrategyListItem } from 'model/modules/strategies/strategies';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { take } from 'lodash';

interface Props {
  strategies: StrategyListItem[];
  title?: string | null;
}

const StrategiesShortGrid: FC<Props> = ({ strategies, title }) => {
  const { t } = useTranslation();

  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.3)';

  const navigate = useNavigate();

  const gapBetweenCards = 16;

  return (
    <>
      <GridHeading
        trailingLink={{
          text: t('allItems'),
          path: AppRoute.strategies,
        }}
      >
        {title ?? t('strategiesTitle')}
      </GridHeading>
      <Flex w="100%">
        {take(strategies, 3).map((strategy, index) => (
          <AppCard
            overflow="hidden"
            cursor="pointer"
            onClick={() => navigate(AppRoute.strategiesDetail(strategy.id))}
            h="230px"
            p="15px"
            bgColor={strategy.backgroundColor ?? ''}
            key={index}
            position="relative"
            mr={(index + 1) % 3 === 0 ? '0' : `${gapBetweenCards}px`}
            w={`calc(100% / 3 - ${gapBetweenCards / 2}px)`}
          >
            <Image
              position="absolute"
              src={strategy.image}
              right="0"
              top="0"
              w="230px"
              h="230px"
            />
            <Flex
              h="100%"
              zIndex={5}
              position="relative"
              flexDir="column"
              justifyContent="flex-end"
            >
              <Text
                textShadow={textShadow}
                color={Color.OnPrimary}
                fontWeight={800}
                fontSize="22px"
                mb="5px"
              >
                {strategy.title}
              </Text>
              <Text
                textShadow={textShadow}
                color={Color.OnPrimary}
                fontWeight={700}
                fontSize="26px"
                mb="5px"
              >
                {strategy.subtitle1}
              </Text>
              <Text
                textShadow={textShadow}
                color={Color.OnPrimary}
                fontWeight={700}
                fontSize={FontSize.sm}
              >
                {strategy.subtitle2}
              </Text>
            </Flex>
          </AppCard>
        ))}
      </Flex>
    </>
  );
};

export default StrategiesShortGrid;
